import axios from 'axios'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Button } from 'reactstrap'
import EmployeeFeedbackModal from '../Dashboard/EmployeeFeedbackModal'

const TYPE_LABEL = {
  probation: 'Periudha Provuese',
  exit: 'Largim',
  renewal: 'Vazhdim i Kontratës',
}

// Shown in the user profile (Feedback tab) to managers / super admin.
// Lists the completed manager-feedback surveys for this employee, read-only.
const UserFeedbackHistory = ({ userId }) => {
  const [surveys, setSurveys] = useState([])
  const [loading, setLoading] = useState(true)
  const [selected, setSelected] = useState(null)

  useEffect(() => {
    if (!userId) return
    setLoading(true)
    axios
      .get(`manager-feedback-surveys/employee/${userId}`)
      .then((r) => setSurveys((r.data?.data || []).filter((s) => s.status === 'completed')))
      .catch(() => setSurveys([]))
      .finally(() => setLoading(false))
  }, [userId])

  if (loading) return <div className='p-3'>Duke ngarkuar...</div>
  if (!surveys.length) return <div className='p-3 text-muted'>Nuk ka feedback për këtë punonjës.</div>

  return (
    <div className='p-3'>
      <EmployeeFeedbackModal survey={selected} onClose={() => setSelected(null)} />
      {surveys.map((s) => (
        <div
          key={s._id}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 10,
            border: '1px solid #e4eaec',
            borderRadius: 5,
            marginBottom: 10,
          }}
        >
          <div>
            <div style={{ fontWeight: 600 }}>{TYPE_LABEL[s.type] || s.type}</div>
            <small className='text-muted'>
              Menaxheri: {s.manager?.first_name} {s.manager?.last_name}
              {' · '}
              {moment(s.completedAt).format('DD.MM.YYYY')}
            </small>
          </div>
          <Button size='sm' color='info' onClick={() => setSelected(s)}>
            Shiko
          </Button>
        </div>
      ))}
    </div>
  )
}

export default UserFeedbackHistory
